interface SelectedTextIndicatorProps {
  selectedText: string | null
  selectedLineCount: number
}

/**
 * Component that displays an indicator when text is selected in the editor.
 * Shows the selected text preview and line count.
 */
export function SelectedTextIndicator({ 
  selectedText, 
  selectedLineCount 
}: SelectedTextIndicatorProps) {
  if (!selectedText) return null

  return (
    <div className='mb-3 rounded-lg bg-amber-50 px-3 py-2 dark:bg-amber-900/20'>
      <div className='flex items-center justify-between'>
        <span className='text-xs font-medium text-amber-700 dark:text-amber-400'>
          Selected text
        </span>
        <span className='text-xs text-amber-600 dark:text-amber-500'>
          {selectedLineCount}{' '}
          {selectedLineCount === 1 ? 'line' : 'lines'}
        </span>
      </div>
      <div className='mt-1 max-h-20 overflow-y-auto'>
        <p className='line-clamp-3 text-xs text-amber-600 dark:text-amber-500'>
          {typeof selectedText === 'string' && selectedText.length > 150
            ? selectedText.slice(0, 150) + '...'
            : selectedText}
        </p>
      </div>
    </div>
  )
}